<template>
  <div class="filters-main-div">
    <!-- <div class="toggle-icon toggle-icon-right" :style="toggleIconPosition" @click="toggleDrawer">
      <v-img :src="drawer ? right_icon : left_icon" width="11" height="11"></v-img>
    </div> -->

    <v-icon class="toggle-icon" :icon="drawer ? 'mdi-chevron-double-right' : 'mdi-chevron-double-left'
      " :style="toggleIconPosition" @click="toggleDrawer"></v-icon>

    <v-navigation-drawer
      :style="{
        top: $route.name === 'FluidsDataStudioTwo' ? '118px !important' : '98px !important',
        height: $route.name === 'FluidsDataStudioTwo' ? 'calc(100vh - 56px) !important' : 'calc(100vh - 93px) !important'
      }"
      class="filter-drawer" v-model="drawer" location="right" :mini-variant="miniVariant"
      @update:mini-variant="updateMiniVariant" :class="{ 'drawer-inactive': !drawer }" permanent>
      <div v-if="rail" class="" style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;">
        <!-- <div></div> -->
        <v-img src="../../../../src/assets/Svg/filter-square.svg">
        </v-img>
      </div>
      <v-row no-gutters class="inner-content filter-drawer-content" v-if="!rail">
        <v-col cols="12" class="pa-0">
          <div class="filter-top-div">
            <div class="filter-heading">Filters</div>
            <v-btn v-if="isFilterSelected" @click="resetSelectedFilter" flat class="reset-btn ml-2 text-none">
              <v-img :src="reset_icon" alt="reset-icon" width="15" height="15" class="mr-1"></v-img>
              <span>Create</span>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" class="pt-2 pb-2 saved-filter-bottom-border">
          <label for="">Saved Filters</label>
          <v-select v-model="selectedFilter" variant="solo" class="custom-field" placeholder="Saved Filters"
            :items="filteredFilters.map((filter) => filter.name)" @update:modelValue="onSelectFilter">
            <!-- Search Input -->
            <template #prepend-item>
              <v-text-field variant="solo" class="custom-field mx-4" v-model="filterSearchQuery"
                placeholder="Search Saved Filters" dense outlined clearable @input="filterFilterList"
                @click:clear="resetFilterList" hide-details></v-text-field>
            </template>
          </v-select>
        </v-col>
        <!-- <v-col cols="12" class="pt-4">
          <div class="new-filter-text">Create Filter</div>
        </v-col> -->
        <v-col cols="12" class="pt-2">
          <label for="">Filter name</label>
          <v-text-field v-model="filterName" variant="solo" class="custom-field" required placeholder="Filter Name"
            hide-details outlined></v-text-field>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Fluid Type(s)</label>
          <v-select variant="solo" v-model="selectedSampleKind" multiple chips clearable closable-chips
            placeholder="Fluid Type(s)" :items="filteredSampleKinds.map((fluidType) => fluidType.name)"
            :return-object="false" class="custom-y-axis-chips custom-field" @update:modelValue="onSelectSampleKind">
            <!-- Search Input -->
            <template #prepend-item>
              <v-text-field variant="solo" class="custom-field mx-4" v-model="sampleKindSearchQuery"
                placeholder="Search Fluid Type(s)" dense outlined clearable @input="filterSampleKindList"
                @click:clear="resetSampleKindList" hide-details></v-text-field>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Sample Type(s)</label>
          <v-select variant="solo" v-model="selectedSampleType" multiple chips clearable closable-chips
            placeholder="Sample Type(s)" :items="filteredSampleTypes"
            item-title="name"
            item-value="name"
            :return-object="false" class="custom-y-axis-chips custom-field" @update:modelValue="onSelectSampleType">
            <!-- Search Input -->
            <template #prepend-item>
              <v-text-field variant="solo" class="custom-field mx-4" v-model="sampleTypeSearchQuery"
                placeholder="Search Sample Type(s)" dense outlined clearable @input="filterSampleTypeList"
                @click:clear="resetSampleTypeList" hide-details></v-text-field>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Fluid Classification(s)</label>
          <v-select variant="solo" v-model="selectedfluidClassification" multiple chips clearable closable-chips
            placeholder="Fluid Classification(s)" :items="filteredfluidClassifications" item-title="name"
            item-value="name"
            :return-object="false" class="custom-y-axis-chips custom-field" @update:modelValue="onSelectfluidClassification">
            <!-- Search Input -->
            <template #prepend-item>
              <v-text-field variant="solo" class="custom-field mx-4" v-model="fluidClassificationSearchQuery"
                placeholder="Search Fluid Classification(s)" dense outlined clearable @input="filterfluidClassificationList"
                @click:clear="resetfluidClassificationList" hide-details></v-text-field>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Sample ID(s)</label>
          <v-select variant="solo" v-model="selectedSampleID" multiple chips clearable closable-chips
            placeholder="Sample ID(s)" :items="filteredSampleIDs.map((sampleID) => sampleID.name)"
            :return-object="false" class="custom-y-axis-chips custom-field" @update:modelValue="onSelectSampleID">
            <!-- Search Input -->
            <template #prepend-item>
              <v-text-field variant="solo" class="custom-field mx-4" v-model="sampleIDSearchQuery"
                placeholder="Sample ID(s)" dense outlined clearable @input="filterSampleIDList"
                @click:clear="resetSampleIDList" hide-details></v-text-field>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Asset(s)</label>
          <v-select variant="solo" v-model="selectedAsset" multiple chips clearable closable-chips placeholder="Assets"
            :items="filteredAssets.map((asset) => asset.name)" :return-object="false"
            class="custom-y-axis-chips custom-field" @update:modelValue="onSelectAsset">
            <!-- Search Input -->
            <template #prepend-item>
              <v-text-field variant="solo" class="custom-field mx-4" v-model="assetSearchQuery"
                placeholder="Search Assets" dense outlined clearable @input="filterAssetList"
                @click:clear="resetAssetList" hide-details></v-text-field>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Field(s)</label>
          <v-select variant="solo" v-model="selectedField" multiple chips clearable closable-chips placeholder="Fields"
            :items="filteredFields.map((field) => field.name)" :return-object="false"
            class="custom-y-axis-chips custom-field" @update:modelValue="onSelectField">
            <!-- Search Input -->
            <template #prepend-item>
              <v-text-field variant="solo" class="custom-field mx-4" v-model="fieldSearchQuery"
                placeholder="Search Fields" dense outlined clearable @input="filterFieldList"
                @click:clear="resetFieldList" hide-details></v-text-field>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Well(s)</label>
          <v-select variant="solo" :items="filteredWells.map((well) => well.name)" multiple chips clearable
            closable-chips placeholder="Well(s)" item-title="displayName" item-value="name" :return-object="false"
            class="custom-y-axis-chips custom-field" v-model="selectedWell" @update:modelValue="onSelectWell">
            <!-- Search Input -->
            <template #prepend-item>
              <v-text-field variant="solo" class="custom-field mx-4" v-model="wellSearchQuery"
                placeholder="Search Well(s)" dense outlined clearable @input="filterWellList"
                @click:clear="resetWellList" hide-details></v-text-field>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Reservoir(s)</label>
          <v-select variant="solo" v-model="selectedReservoir"
            :items="filteredReservoirs.map((reservoir) => reservoir.name)" multiple chips clearable closable-chips
            placeholder="Reservoirs" item-title="displayName" item-value="name" :return-object="false"
            class="custom-y-axis-chips custom-field" @update:modelValue="onSelectReservoir">
            <!-- Search Input -->
            <template #prepend-item>
              <v-text-field variant="solo" class="custom-field mx-4" v-model="reservoirSearchQuery"
                placeholder="Search Reservoirs" dense outlined clearable @input="filterReservoirList"
                @click:clear="resetReservoirList" hide-details></v-text-field>
            </template>
          </v-select>
        </v-col>
        <!-- <v-col cols="12" class="pt-2">
          <label for="">Select Minimum Date</label>
          <VueDatePicker v-model="minDate" placeholder="Select minimum date" :enable-time-picker="false"
            :disabled-dates="disableFutureDates" />
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Select Maximum Date</label>
          <VueDatePicker v-model="maxDate" placeholder="Select maximum date" :enable-time-picker="false"
            :disabled-dates="disableFutureDates" />
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Select Sample Kind(s)</label>
          <v-select v-model="selectedSampleKind" :items="sampleKinds" multiple chips clearable closable-chips
            placeholder="Select sample kind" item-title="displayName" item-value="name" :return-object="false"
            class="custom-y-axis-chips" @update:modelValue="onSelectSampleKinds">
          </v-select>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Minimum Depth</label>
          <v-text-field v-model="minDepth" placeholder="Enter minimum depth" type="number" :rules="numberRules"
            variant="outlined"></v-text-field>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Maximum Depth</label>
          <v-text-field v-model="maxDepth" placeholder="Enter maximum depth" type="number" :rules="numberRules"
            variant="outlined"></v-text-field>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Mininum Formation Pressure</label>
          <v-text-field v-model="minFormationPressure" placeholder="Enter minimum formation pressure" type="number"
            :rules="numberRules" variant="outlined"></v-text-field>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Maximum Formation Pressure</label>
          <v-text-field v-model="maxFormationPressure" placeholder="Enter maximum formation pressure" type="number"
            :rules="numberRules" variant="outlined"></v-text-field>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Minimum Formation Temperature</label>
          <v-text-field v-model="minFormationTemperature" placeholder="Enter minimum formation temperature"
            type="number" :rules="numberRules" variant="outlined"></v-text-field>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Maximum Formation Temperature</label>
          <v-text-field v-model="maxFormationTemperature" placeholder="Enter maximum formation temperature"
            type="number" :rules="numberRules" variant="outlined"></v-text-field>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Fluid Sample ID</label>
          <vue3-tags-input :tags="fluidSampleID" placeholder="Select fluid sample id"
            @on-tags-changed="handleChangeTag" />
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Fluid Sample Container ID</label>
          <vue3-tags-input :tags="fluidSampleContainerID" placeholder="Select fluid sample container id"
            @on-tags-changed="handleChangeTagContainer" />
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Max Samples</label>
          <v-text-field v-model="maxSamples" placeholder="Enter Samples" type="number" :rules="numberRules"
            variant="outlined"></v-text-field>
        </v-col>
        <v-col cols="12" class="pt-2">
          <label for="">Select Source(s)</label>
          <v-text-field v-model="source" placeholder="Enter source" variant="outlined"></v-text-field>
        </v-col> -->
        <template v-if="!isFilterSelected">
          <v-col cols="6" class="pa-0 pt-3 pr-1">
            <v-btn @click="resetFilter" block flat class="reset-btn text-none">
              <v-img :src="delete_black" alt="save" width="15px" height="15px" class="mr-2"></v-img>
              <span>Discard</span>
            </v-btn>
          </v-col>
          <v-col cols="6" class="pa-0 pt-3 pl-1">
            <v-btn block flat class="save-btn filter-wrap-btn text-none" @click="saveFilter" :loading="createLoading"
              :disabled="isSaveDisabled">
              <v-img :src="save" alt="save" width="15px" height="15px" class="mr-2"></v-img>
              <span>Save</span></v-btn>
          </v-col>
        </template>
        <template v-else>
          <v-col cols="6" class="pa-0 pt-3 pr-1">
            <v-btn @click="showDeleteConfirmation" block flat class="reset-btn text-none">
              <v-img :src="delete_black" alt="delete" width="15px" height="15px" class="mr-2"></v-img>
              <span>Discard</span>
            </v-btn>
          </v-col>
          <v-col cols="6" class="pa-0 pt-3 pl-1">
            <v-btn block flat class="save-btn filter-wrap-btn text-none" @click="updateFilter" :loading="updateLoading"
              :disabled="isUpdateDisabled">
              <v-img :src="save" alt="update" width="15px" height="15px" class="mr-2"></v-img>
              <span>Update</span>
            </v-btn>
          </v-col>

        </template>
      </v-row>
    </v-navigation-drawer>

    <v-dialog transition="dialog-top-transition" v-model="confirmDeleteDialog" width="417">
      <div class="cross-btn-div" @click="closeDeleteConfirmation">
        <v-img :src="cross" alt="close"></v-img>
      </div>
      <v-alert title="Delete Filter" text="Are you sure you want to delete filter?">
        <div class="alert-btns-div">
          <v-btn class="cancel-btn" flat @click="closeDeleteConfirmation">Cancel</v-btn>
          <v-btn class="delete-btn" flat @click="deleteFilter" :loading="deleteLoading">
            <v-img :src="delete_icon" alt="delete-icon" width="16" height="15" class="mr-2"></v-img>
            Delete Filter</v-btn>
        </div>
      </v-alert>
    </v-dialog>

    <!-- <v-dialog v-model="showDefaultDialog" transition="dialog-top-transition" max-width="417">
      <div class="cross-btn-div" @click="showDefaultDialog = false">
        <v-img :src="cross" alt="close"></v-img>
      </div>
      <v-alert title="Default Filter" text="Do you want to make this filter as a default ?">
        <div class="alert-btns-div">
          <v-btn class="cancel-btn" @click="showDefaultDialog = false">Cancel</v-btn>
          <v-btn class="save-btn" text @click="confirmDefaultFilter" :loading="defaultLoading">Save</v-btn>
        </div>
      </v-alert>
    </v-dialog> -->

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout">
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import api from "../../../axiosInterceptor";
import Vue3TagsInput from 'vue3-tags-input';
import screenWidthMixin from "../../../assets/JS/screenWidthMixin";
import { eventBus } from "../../../eventBus.js";

export default {
  name: "Filters",
  components: {
    Vue3TagsInput
  },
  mixins: [screenWidthMixin],
  data: () => ({
    cross: require("../../../assets/Images/Buttons/cross.png"),
    left_icon: require("../../../assets/Images/left-double.png"),
    right_icon: require("../../../assets/Images/right-double.png"),
    reset_icon: require("../../../assets/Svg/add.svg"),
    delete_icon: require("../../../assets/Svg/Chart/delete-white.svg"),
    delete_black: require("../../../assets/Svg/delete-black.svg"),
    save: require("../../../assets/Images/save btn.png"),
    drawer: false,
    rail: true,
    miniVariant: false,
    filters: [],
    filterSearchQuery: "", // Search query for filters
    filteredFilters: [],
    sampleKindSearchQuery: "", // Search query for filters
    sampleTypeSearchQuery: "",
    fluidClassificationSearchQuery: "",
    sampleIDSearchQuery: "",
    filteredSampleKinds: [],
    filteredSampleTypes: [],
    filteredSampleIDs: [],
    assetSearchQuery: "", // Search query for filters
    filteredAssets: [],
    fieldSearchQuery: "", // Search query for filters
    filteredFields: [],
    wellSearchQuery: "", // Search query for filters
    filteredWells: [],
    reservoirSearchQuery: "", // Search query for filters
    filteredReservoirs: [],
    filterID: null,
    filterName: null,
    selectedFilter: null,
    filterData: {},
    assets: [],
    selectedAsset: [],
    previousSelectedAssets: [],
    fields: [],
    selectedField: [],
    previousSelectedFields: [],
    wells: [],
    selectedWell: [],
    previousSelectedWells: [],
    reservoirs: [],
    selectedReservoir: [],
    previousSelectedReservoir: [],
    minDate: null,
    maxDate: null,
    sampleIDs: [],
    sampleKinds: [
      "bhs samples",
      "blend-gas",
      "blend-liquid",
      "brine",
      "condensate",
      "filtrate",
      "gas",
      "gas-dry",
      "mud filtrate",
      "mud sample",
      "oil & water",
      "oil-base",
      "oil-black",
      "oil-dead",
      "oil-heavy",
      "oil-unknown",
      "oil-volatile",
      "other",
      "recomb-fluid",
      "recomb-gas",
      "rinse-post",
      "rinse-pre",
      "solid",
      "sto",
      "toluene",
      "water",
      "water/condensate",
      "synthetic",
      "separator water",
      "separator oil",
      "separator gas",
      "downhole cased",
      "downhole open",
      "recombined",
      "wellhead",
      "commingled",
    ],
    sampleTypes: [],
    fluidClassifications: [],
    selectedSampleKind: [],
    selectedSampleType: [],
    selectedfluidClassification: [],
    previousSelectedSampleKinds: [],
    previousSelectedSampleTypes: [],
    previousSelectedfluidClassifications: [],
    selectedSampleID: [],
    previousSelectedSampleIDs: [],
    minDepth: null,
    maxDepth: null,
    minFormationPressure: null,
    maxFormationPressure: null,
    minFormationTemperature: null,
    maxFormationTemperature: null,
    fluidSampleID: [],
    fluidSampleContainerID: [],
    maxSamples: null,
    source: null,
    createLoading: false,
    deleteLoading: false,
    updateLoading: false,
    confirmDeleteDialog: false,
    numberRules: [
      (v) => !!v || "Number is required",
      (v) => (v && v > 0) || "Number must be positive",
    ],
    snackbar: {
      visible: false,
      message: "",
      color: "success",
      timeout: 3000,
    },
    // showDefaultDialog: false,
    defaultLoading: false,
    filterCalled: false
  }),
  props: {
    selectedType: {
      type: String
    },
    filterFromChart: {
      type: Array
    },
    callDefaultFilter: {
      type: Boolean,
      default: false,
      required: true
    },
  },
  watch: {
    isAnySelectBoxActive(newVal) {
      if (newVal) {
        localStorage.setItem("filterActive", "true");
      } else {
        localStorage.removeItem("filterActive");
      }
    },
    callDefaultFilter(val) {
      if (val) {
        this.defaultFilterData();
        this.$emit('reset-call-default-filter');
      }
    },
    filterFromChart(val) {
      if (val) {
        this.defaultFilterData(val);
        this.$emit('reset-call-default-filter');
      }
      else {
        // Only reset filter if we're not in studio mode or if there's no pending filter
        const pendingFilterData = localStorage.getItem("pendingFilterData");
        const filterActive = localStorage.getItem("filterActive");
        
        if (this.$route.name === "FluidsDataStudioTwo" && pendingFilterData && filterActive === "true") {
          // Don't reset the filter in studio mode if there's a pending filter
          console.log("Preserving filter in studio mode - not resetting due to pending filter");
        } else {
          this.resetFilter();
        }
      }
    },
  },
  computed: {
    isAnySelectBoxActive() {
      return (
        this.selectedSampleKind.length > 0 ||
        this.selectedSampleType.length > 0 ||
        this.selectedfluidClassification.length > 0 ||
        this.selectedSampleID.length > 0 ||
        this.selectedAsset.length > 0 ||
        this.selectedField.length > 0 ||
        this.selectedWell.length > 0 ||
        this.selectedReservoir.length > 0
      );
    },
    toggleIconPosition() {
      let right = this.drawer ? "277px" : "30px";
      let top = this.$route && this.$route.name === 'FluidsDataStudioTwo' ? "75px" : undefined;
      return top ? `right: ${right}; top: ${top};` : `right: ${right};`;
    },
    // filteredfilters() {
    //   return this.filters.filter((filter) => filter.name);
    // },
    filteredFilters() {
      const query = this.filterSearchQuery.toLowerCase();
      return this.filters.filter(
        (filter) => filter.name && filter.name.toLowerCase().includes(query)
      );
    },
    // filteredSampleKinds() {
    //   return this.sampleKinds.filter((sampleKind) => sampleKind.name);
    // },
    filteredSampleKinds() {
      const query = this.sampleKindSearchQuery.toLowerCase();
      return this.sampleKinds.filter(
        (fluidType) => fluidType.name && fluidType.name.toLowerCase().includes(query)
      );
    },
    filteredSampleTypes() {
      const query = this.sampleTypeSearchQuery.toLowerCase();
      return this.sampleTypes.filter(
        (sampleType) => sampleType.name && sampleType.name.toLowerCase().includes(query)
      );
    },
    filteredfluidClassifications() {
      const query = this.fluidClassificationSearchQuery.toLowerCase();
      return this.fluidClassifications.filter(
        (fluidClassification) => fluidClassification.name && fluidClassification.name.toLowerCase().includes(query)
      );
    },
    filteredSampleIDs() {
      const query = this.sampleIDSearchQuery.toLowerCase();
      return this.sampleIDs.filter(
        (sampleID) => sampleID.name && sampleID.name.toLowerCase().includes(query)
      );
    },
    // filteredAssets() {
    //   return this.assets.filter((asset) => asset.name);
    // },
    filteredAssets() {
      const query = this.assetSearchQuery.toLowerCase();
      return this.assets.filter(
        (asset) => asset.name && asset.name.toLowerCase().includes(query)
      );
    },
    // filteredFields() {
    //   return this.fields.filter((field) => field.name);
    // },
    filteredFields() {
      const query = this.fieldSearchQuery.toLowerCase();
      return this.fields.filter(
        (field) => field.name && field.name.toLowerCase().includes(query)
      );
    },
    // filteredWells() {
    //   return this.wells.filter((well) => well.name);
    // },
    filteredWells() {
      const query = this.wellSearchQuery.toLowerCase();
      return this.wells.filter(
        (well) => well.name && well.name.toLowerCase().includes(query)
      );
    },
    // filteredReservoir() {
    //   return this.reservoirs.filter((reservoir) => reservoir.name);
    // },
    filteredReservoirs() {
      const query = this.reservoirSearchQuery.toLowerCase();
      return this.reservoirs.filter(
        (reservoir) => reservoir.name && reservoir.name.toLowerCase().includes(query)
      );
    },
    ...mapGetters("tenantId", ["getUser"]),
    userFullName() {
      if (this.getUser && this.getUser.firstName && this.getUser.lastName) {
        return `${this.getUser.firstName} ${this.getUser.lastName}`;
      }
    },
    isFilterSelected() {
      const lastView = localStorage.getItem('activeMenu');
      if (lastView && lastView.toLowerCase() === "data management") {
        return this.selectedFilter !== null && this.selectedFilter !== undefined;
      } else {
        if (this.filterFromChart) {
          return (
            this.selectedFilter !== null &&
            this.selectedFilter !== undefined
          ) || (
              this.filterFromChart?.ID !== undefined &&
              this.filterFromChart?.ID !== null
            );
        }
        else {
          return this.selectedFilter !== null && this.selectedFilter !== undefined;
        }
      }
    },
    // isSaveDisabled() {
    //   return (
    //     !this.filterName ||
    //     (this.selectedAsset.length === 0 &&
    //       this.selectedField.length === 0 &&
    //       this.selectedReservoir.length === 0 &&
    //       this.selectedWell.length === 0 &&
    //       !this.minDate &&
    //       !this.maxDate &&
    //       this.selectedSampleKind.length === 0 &&
    //       !this.minDepth &&
    //       !this.maxDepth &&
    //       !this.minFormationPressure &&
    //       !this.maxFormationPressure &&
    //       !this.minFormationTemperature &&
    //       !this.maxFormationTemperature &&
    //       this.fluidSampleID.length === 0 &&
    //       this.fluidSampleContainerID.length === 0 &&
    //       !this.maxSamples &&
    //       !this.source)
    //   );
    // },
    isSaveDisabled() {
      const hasFilterValue =
        this.filterName &&
        this.selectedAsset.length > 0 ||
        this.selectedField.length > 0 ||
        this.selectedReservoir.length > 0 ||
        this.selectedWell.length > 0 ||
        this.minDate ||
        this.maxDate ||
        this.selectedSampleKind.length > 0 ||
        this.selectedSampleType.length > 0 ||
        this.selectedfluidClassification.length > 0 ||
        this.selectedSampleID.length > 0 ||
        this.minDepth ||
        this.maxDepth ||
        this.minFormationPressure ||
        this.maxFormationPressure ||
        this.minFormationTemperature ||
        this.maxFormationTemperature ||
        this.fluidSampleID.length > 0 ||
        this.fluidSampleContainerID.length > 0 ||
        this.maxSamples ||
        this.source;

      const invalidNumberValues =
        (this.minDepth && this.numberRules.some(rule => rule(this.minDepth) !== true)) ||
        (this.maxDepth && this.numberRules.some(rule => rule(this.maxDepth) !== true)) ||
        (this.minFormationPressure && this.numberRules.some(rule => rule(this.minFormationPressure) !== true)) ||
        (this.maxFormationPressure && this.numberRules.some(rule => rule(this.maxFormationPressure) !== true)) ||
        (this.minFormationTemperature && this.numberRules.some(rule => rule(this.minFormationTemperature) !== true)) ||
        (this.maxFormationTemperature && this.numberRules.some(rule => rule(this.maxFormationTemperature) !== true)) ||
        (this.maxSamples && this.numberRules.some(rule => rule(this.maxSamples) !== true));

      return !hasFilterValue || invalidNumberValues;
    },
    // isUpdateDisabled() {
    //   return (
    //     !this.filterName ||
    //     (this.selectedAsset.length === 0 &&
    //       this.selectedField.length === 0 &&
    //       this.selectedReservoir.length === 0 &&
    //       this.selectedWell.length === 0 &&
    //       !this.minDate &&
    //       !this.maxDate &&
    //       this.selectedSampleKind.length === 0 &&
    //       !this.minDepth &&
    //       !this.maxDepth &&
    //       !this.minFormationPressure &&
    //       !this.maxFormationPressure &&
    //       !this.minFormationTemperature &&
    //       !this.maxFormationTemperature &&
    //       this.fluidSampleID.length === 0 &&
    //       this.fluidSampleContainerID.length === 0 &&
    //       !this.maxSamples &&
    //       !this.source)
    //   );
    // },
    isUpdateDisabled() {
      const hasFilterValue =
        this.filterName &&
        this.selectedAsset.length > 0 ||
        this.selectedField.length > 0 ||
        this.selectedReservoir.length > 0 ||
        this.selectedWell.length > 0 ||
        this.minDate ||
        this.maxDate ||
        this.selectedSampleKind.length > 0 ||
        this.selectedSampleType.length > 0 ||
        this.selectedfluidClassification.length > 0 ||
        this.selectedSampleID.length > 0 ||
        this.minDepth ||
        this.maxDepth ||
        this.minFormationPressure ||
        this.maxFormationPressure ||
        this.minFormationTemperature ||
        this.maxFormationTemperature ||
        this.fluidSampleID.length > 0 ||
        this.fluidSampleContainerID.length > 0 ||
        this.maxSamples ||
        this.source;

      const invalidNumberValues =
        (this.minDepth && this.numberRules.some(rule => rule(this.minDepth) !== true)) ||
        (this.maxDepth && this.numberRules.some(rule => rule(this.maxDepth) !== true)) ||
        (this.minFormationPressure && this.numberRules.some(rule => rule(this.minFormationPressure) !== true)) ||
        (this.maxFormationPressure && this.numberRules.some(rule => rule(this.maxFormationPressure) !== true)) ||
        (this.minFormationTemperature && this.numberRules.some(rule => rule(this.minFormationTemperature) !== true)) ||
        (this.maxFormationTemperature && this.numberRules.some(rule => rule(this.maxFormationTemperature) !== true)) ||
        (this.maxSamples && this.numberRules.some(rule => rule(this.maxSamples) !== true));

      return !hasFilterValue || invalidNumberValues;
    },
  },
  methods: {
    resetFilterList() {
      // Reset the search query and display all filters
      this.filterSearchQuery = "";
      this.filteredFilters = this.filters;
    },
    resetSampleKindList() {
      // Reset the search query and display all filters
      this.sampleKindSearchQuery = "";
      this.filteredSampleKinds = this.sampleKinds;
    },
    resetSampleTypeList() {
      // Reset the search query and display all filters
      this.sampleTypeSearchQuery = "";
      this.filteredSampleTypes = this.sampleTypes;
    },
    resetfluidClassificationList() {
      // Reset the search query and display all filters
      this.fluidClassificationSearchQuery = "";
      this.filteredfluidClassifications = this.fluidClassifications;
    },
    resetSampleIDList() {
      // Reset the search query and display all filters
      this.sampleIDSearchQuery = "";
      this.filteredSampleIDs = this.sampleIDs;
    },
    resetAssetList() {
      // Reset the search query and display all filters
      this.assetSearchQuery = "";
      this.filteredAssets = this.assets;
    },
    resetFieldList() {
      // Reset the search query and display all filters
      this.fieldSearchQuery = "";
      this.filteredFields = this.fields;
    },
    resetWellList() {
      // Reset the search query and display all filters
      this.wellSearchQuery = "";
      this.filteredWells = this.wells;
    },
    resetReservoirList() {
      // Reset the search query and display all filters
      this.reservoirSearchQuery = "";
      this.filteredFeservoirs = this.reservoirs;
    },
    filterFilterList() {
      // Filter the list based on the search query
      const query = this.filterSearchQuery.toLowerCase();
      this.filteredFilters = this.filters.filter((filter) =>
        filter.name.toLowerCase().includes(query)
      );
    },
    filterSampleKindList() {
      // Filter the list based on the search query
      const query = this.sampleKindSearchQuery.toLowerCase();
      this.filteredSampleKinds = this.sampleKinds.filter((fluidType) =>
      fluidType.name.toLowerCase().includes(query)
      );
    },
    filterSampleTypeList() {
      // Filter the list based on the search query
      const query = this.sampleTypeSearchQuery.toLowerCase();
      this.filteredSampleTypes = this.sampleTypes.filter((sampleType) =>
      sampleType.name.toLowerCase().includes(query)
      );
    },
    filterfluidClassificationList() {
      // Filter the list based on the search query
      const query = this.fluidClassificationSearchQuery.toLowerCase();
      this.filteredfluidClassifications = this.fluidClassifications.filter((fluidClassification) =>
      fluidClassification.name.toLowerCase().includes(query)
      );
    },
    filterSampleIDList() {
      // Filter the list based on the search query
      const query = this.sampleIDSearchQuery.toLowerCase();
      this.filteredSampleIDs = this.sampleIDs.filter((sampleID) =>
        sampleID.name.toLowerCase().includes(query)
      );
    },
    filterAssetList() {
      // Filter the list based on the search query
      const query = this.assetSearchQuery.toLowerCase();
      this.filteredAssets = this.assets.filter((asset) =>
        asset.name.toLowerCase().includes(query)
      );
    },
    filterFieldList() {
      // Filter the list based on the search query
      const query = this.fieldSearchQuery.toLowerCase();
      this.filteredFields = this.fields.filter((field) =>
        field.name.toLowerCase().includes(query)
      );
    },
    filterWellList() {
      // Filter the list based on the search query
      const query = this.wellSearchQuery.toLowerCase();
      this.filteredWells = this.wells.filter((well) =>
        well.name.toLowerCase().includes(query)
      );
    },
    filterReservoirList() {
      // Filter the list based on the search query
      const query = this.reservoirSearchQuery.toLowerCase();
      this.filteredReservoirs = this.reservoirs.filter((reservoir) =>
        reservoir.name.toLowerCase().includes(query)
      );
    },
    showSnackbar(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
    handleChangeTag(tags) {
      this.fluidSampleID = tags;
    },
    handleChangeTagContainer(tags) {
      this.fluidSampleContainerID = tags;
    },
    disableFutureDates(date) {
      const today = new Date();
      return date > today;
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
      this.rail = !this.rail
      this.$emit("drawerStateChanged", this.drawer);
      this.$emit("drawerValue", this.drawer)
      
      // Emit resizeChart event when filter drawer state changes
      this.$nextTick(() => {
        eventBus.emit("resizeChart");
        eventBus.emit("filterDrawerToggled");
      });
    },
    updateMiniVariant(value) {
      this.miniVariant = value;
    },
    checkScreenWidth() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 768) {
        this.drawer = false;
      } else {
        this.drawer = false;
      }
    },
    handleKeydown(event) {
      if (event.key === "Escape") {
        this.toggleDrawer();
      }
    },
    getAllfilters() {
      this.timeoutMessage = "";
      api
        .get("public/api/filters")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.filters = this.sortAlphabetically(response.data.data.filters.filter((filter) => filter.name));
            this.filteredFilters = this.filters;
          }
          else if (response && response.data && response.data.message) {
            this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching assets";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        });
    },

    getAllSampleKinds() {
      this.timeoutMessage = "";
      api
        .get("public/api/summary/fluidType")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.sampleKinds = this.sortAlphabetically(response.data.data.columnSummary.filter((fluidType) => fluidType.name));
            this.filteredSampleKinds = this.sampleKinds;
          }
          else if (response && response.data && response.data.message) {
            this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching assets";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        });
    },
    getAllSampleTypes() {
      this.timeoutMessage = "";
      api
        .get("/public/api/unique-values/sampleType")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.sampleTypes = this.sortAlphabetically(response.data.data.columnUniqueValues.Values.map(value => ({ name: value })));
            this.filteredSampleTypes = this.sampleTypes;
          }
          else if (response && response.data && response.data.message) {
            this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching assets";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        });
    },
    getAllfluidClassifications() {
      this.timeoutMessage = "";
      api
        .get("/public/api/unique-values/fluidClassification")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.fluidClassifications = this.sortAlphabetically(response.data.data.columnUniqueValues.Values.map(value => ({ name: value })));
            this.filteredfluidClassifications = this.fluidClassifications;
          }
          else if (response && response.data && response.data.message) {
            this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching assets";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        });
    },
    getAllSampleIDs() {
      this.timeoutMessage = "";
      api
        .get("/public/api/unique-values/fluidSampleID")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.sampleIDs = this.sortAlphabetically(response.data.data.columnUniqueValues.Values.map(value => ({ name: value })));
            this.filteredSampleIDs = this.sampleIDs;
          }
          else if (response && response.data && response.data.message) {
            this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching assets";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        });
    },
    getAllAssets(selectedSampleIDs) {
      this.timeoutMessage = "";
      let url = "public/api/locations/assets";
      if (selectedSampleIDs && selectedSampleIDs.length > 0) {
        url += `?fluidSampleID=${JSON.stringify(selectedSampleIDs)}`;
      }
      api
        .get(url)
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.assets = this.sortAlphabetically(response.data.data.locations.filter((asset) => asset.name));
            this.filteredAssets = this.assets;
          }
          else if (response && response.data && response.data.message) {
            this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching assets";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        });
    },

    fetchField(selectedSampleIDs, selectedAssets) {
      const assetString = JSON.stringify(selectedAssets);
      const sampleIDString = JSON.stringify(selectedSampleIDs);
      api
        .get(
          `public/api/locations/fields?asset=${encodeURIComponent(assetString)}&fluidSampleID=${encodeURIComponent(sampleIDString)}`
        )
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.fields = this.sortAlphabetically(response.data.data.locations.filter((field) => field.name));
            this.filteredFields = this.fields;
          }
          else if (response && response.data && response.data.message) {
            console.error(response.data.message);
          }
          else {
            console.error("Error in fetching fields");
          }
        })
        .catch((error) => {
          console.error("Error fetching fields:", error);
        });
    },

    fetchReservoir(selectedSampleIDs, selectedAssets, selectedFields) {
      const assetString = JSON.stringify(selectedAssets);
      const fieldString = JSON.stringify(selectedFields);
      const sampleIDString = JSON.stringify(selectedSampleIDs);
      api
        .get(
          `public/api/locations/reservoirs?asset=${encodeURIComponent(
            assetString
          )}&field=${encodeURIComponent(fieldString)}&fluidSampleID=${encodeURIComponent(sampleIDString)}`
        )
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.reservoirs = this.sortAlphabetically(response.data.data.locations.filter((reservoir) => reservoir.name));
            this.filteredReservoirs = this.reservoirs;
          }
          else if (response && response.data && response.data.message) {
            console.error(response.data.message);
          }
          else {
            console.error("Error fetching reservoirs");
          }
        })
        .catch((error) => {
          console.error("Error fetching reservoirs:", error);
        });
    },

    fetchWell(selectedSampleIDs, selectedAssets, selectedFields, selectedReservoirs) {
      const assetString = JSON.stringify(selectedAssets);
      const fieldString = JSON.stringify(selectedFields);
      const reservoirString = JSON.stringify(selectedReservoirs);
      const sampleIDString = JSON.stringify(selectedSampleIDs);
      api
        .get(
          `public/api/locations/wells?asset=${encodeURIComponent(
            assetString
          )}&field=${encodeURIComponent(fieldString)}&reservoir=${encodeURIComponent(
            reservoirString
          )}&fluidSampleID=${encodeURIComponent(sampleIDString)}`
        )
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.wells = this.sortAlphabetically(response.data.data.locations.filter((well) => well.name));
            this.filteredWells = this.wells;
          }
          else if (response && response.data && response.data.message) {
            console.error(response.data.message);
          }
          else {
            console.error("Error fetching wells");
          }
        })
        .catch((error) => {
          console.error("Error fetching wells:", error);
        });
    },
    sortAlphabetically(items) {
      return items.sort((a, b) => {
        const nameA = a.name ? a.name.toLowerCase() : "";
        const nameB = b.name ? b.name.toLowerCase() : "";
        return nameA.localeCompare(nameB);
      });
    },
    updateFilterData() {
      this.filterData = {
        asset: this.selectedAsset,
        field: this.selectedField,
        well: this.selectedWell,
        reservoir: this.selectedReservoir,
        fluidType: this.selectedSampleKind,
        fluidSampleID: this.selectedSampleID,
        sampleType: this.selectedSampleType,
        fluidClassification: this.selectedfluidClassification,
        fluidSampleContainerID: this.fluidSampleContainerID || [],
        source: this.source,
        sampleDate: this.formatDate(),
        depth: {
          min: this.formatNumber(this.minDepth),
          max: this.formatNumber(this.maxDepth),
        },
        formationPressure: {
          min: this.formatNumber(this.minFormationPressure),
          max: this.formatNumber(this.maxFormationPressure),
        },
        formationTemperature: {
          min: this.formatNumber(this.minFormationTemperature),
          max: this.formatNumber(this.maxFormationTemperature),
        },
      };
    },

    onSelectSampleKind(selectedSampleKinds) {
      this.previousSelectedAssets = [...selectedSampleKinds];
      // this.fetchField(selectedAssets);
      // this.fetchReservoir(selectedAssets, []);
      // this.fetchWell(selectedAssets, [], []);
      this.updateFilterData();
      this.emitFilterData();
    },
    onSelectSampleType(selectedSampleTypes) {
      this.previousSelectedSampleTypes = [...selectedSampleTypes];
      this.updateFilterData();
      this.emitFilterData();
    },
    onSelectfluidClassification(selectedfluidClassifications) {
      this.previousSelectedfluidClassifications = [...selectedfluidClassifications];
      this.updateFilterData();
      this.emitFilterData();
    },
    onSelectSampleID(selectedSampleIDs) {
      this.previousSelectedSampleIDs = [...selectedSampleIDs];
      this.getAllAssets(selectedSampleIDs);
      this.fetchField(selectedSampleIDs, []);
      this.updateFilterData();
      this.emitFilterData();
    },
    onSelectAsset(selectedAssets) {
      this.previousSelectedAssets = [...selectedAssets];
      this.fetchField(this.selectedSampleID, selectedAssets);
      this.fetchReservoir(this.selectedSampleID, selectedAssets, []);
      this.fetchWell(this.selectedSampleID, selectedAssets, [], []);
      this.updateFilterData();
      this.emitFilterData();
    },

    onSelectField(selectedFields) {
      this.previousSelectedFields = [...selectedFields];
      this.fetchReservoir(this.selectedSampleID, this.selectedAsset, selectedFields);
      this.fetchWell(this.selectedSampleID, this.selectedAsset, selectedFields, []);
      this.updateFilterData();
      this.emitFilterData();
    },

    onSelectReservoir(selectedReservoirs) {
      this.previousSelectedReservoir = [...selectedReservoirs];
      this.fetchWell(this.selectedSampleID, this.selectedAsset, this.selectedField, selectedReservoirs);
      this.updateFilterData();
      this.emitFilterData();
    },

    onSelectWell(selectedWells) {
      this.previousSelectedWells = [...selectedWells];
      this.updateFilterData();
      this.emitFilterData();
    },

    emitFilterData() {
      let type = this.selectedType;
      if (this.$route.name === "DataManagement") {
        this.$emit("filterApplied", { filterData: this.filterData, type });
      } else if (type) {
        localStorage.setItem("filterApplied", true);
        this.filterCalled = true
        var filterCalled = this.filterCalled;
        this.$emit("filter-data", { filterData: this.filterData, type, filterCalled });
      } else {
        // In studio mode when no chart is selected, preserve the filter for later use
        if (this.$route.name === "FluidsDataStudioTwo") {
          // Store the filter data in localStorage for later application
          localStorage.setItem("pendingFilterData", JSON.stringify(this.filterData));
          localStorage.setItem("filterActive", "true");
          // Don't clear the UI - keep the filter selections visible
          this.showSnackbar("Filter saved. It will be applied when you select a chart.", "success");
        } else {
          this.showSnackbar("Please select a chart first.", "error");
        }
      }
    },

    // onSelectSampleKinds(selectedSampleKind) {
    //   this.previousSelectedSampleKinds = [...selectedSampleKind];

    //   let type = this.selectedType;
    //   this.updateFilterData();

    //   if (this.$route.name === "DataExploration") {
    //     this.$emit('filterApplied', { filterData: this.filterData, type });
    //     return
    //   }
    //   if (type) {
    //     this.$emit('filter-data', { filterData: this.filterData, type });
    //   } else {
    //     this.showSnackbar("Please select chart first.", "error");
    //   }
    // },
    async onSelectFilter(selectedFilterName) {
      // Extract tenant ID from the route path
      const pathSegments = this.$route.path.split('/').filter(Boolean); // Remove empty segments
      const tenantId = pathSegments[0] || null; // First segment is the tenant ID

      if (!tenantId) {
        console.error("Tenant ID missing from URL.");
        return;
      }

      // Find the selected filter object by name
      const selectedFilter = this.filters.find(
        (filter) => filter.name === selectedFilterName
      );

      if (selectedFilter) {
        try {
          // API call (URL remains unchanged)
          const response = await api.get(
            `public/api/filters/${selectedFilter.ID}`
          );

          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.filterData = response.data.data.filter;
            let type = this.selectedType;
            this.selectedFilter = this.filterData.name;
            this.filterID = this.filterData.ID;
            localStorage.setItem("selectedFilterId", this.filterID);
            this.populateFieldsFromFilter(this.filterData);

            if (type && this.$route.name === "FluidsDataStudioTwo") {
              this.$emit('filter-data', { filterData: this.filterData, type });
            } else if (!type && this.$route.name === "DataManagement") {
              this.$emit('filter-data', { filterData: this.filterData });
              this.$emit('filterApplied', { filterData: this.filterData, type });
            } else {
              // In studio mode when no chart is selected, preserve the filter for later use
              if (this.$route.name === "FluidsDataStudioTwo") {
                // Store the filter data in localStorage for later application
                localStorage.setItem("pendingFilterData", JSON.stringify(this.filterData));
                localStorage.setItem("filterActive", "true");
                // Don't clear the UI - keep the filter selections visible
                this.showSnackbar("Filter saved. It will be applied when you select a chart.", "success");
              } else {
                this.showSnackbar("Please select chart first.", "error");
                this.resetFilter();
              }
            }
          } else if (response && response.data && response.data.message) {
            console.error(response.data.message);
          } else {
            console.error("Error fetching filter details");
          }
        } catch (error) {
          console.error("Error fetching filter details:", error);
        }
      }
    },
    async onSelectFilterGet(selectedFilterName) {
      // Extract tenant ID from the route path
      const pathSegments = this.$route.path.split('/').filter(Boolean); // Remove empty segments
      const tenantId = pathSegments[0] || null; // First segment is the tenant ID

      if (!tenantId) {
        console.error("Tenant ID missing from URL.");
        return;
      }

      // Find the selected filter object by name
      const selectedFilter = this.filters.find(
        (filter) => filter.name === selectedFilterName
      );

      if (selectedFilter) {
        try {
          // API call (URL remains unchanged)
          const response = await api.get(
            `public/api/filters/${selectedFilter.ID}`
          );

          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.filterData = response.data.data.filter;
            let type = this.selectedType;
            this.selectedFilter = this.filterData.name;
            this.filterID = this.filterData.ID;
            localStorage.setItem("selectedFilterId", this.filterID);
            this.populateFieldsFromFilter(this.filterData);
          } else if (response && response.data && response.data.message) {
            console.error(response.data.message);
          } else {
            console.error("Error fetching filter details");
          }
        } catch (error) {
          console.error("Error fetching filter details:", error);
        }
      }
    },
    async defaultFilterData(filterDataVal) {
      // Extract tenant ID from the route path
      const pathSegments = this.$route.path.split('/').filter(Boolean); // Remove empty segments
      const tenantId = pathSegments[0] || null; // First segment is the tenant ID

      if (!tenantId) {
        console.error("Tenant ID missing from URL.");
        return;
      }

      const getDefaultFilterID = localStorage.getItem("defaultFilter");
      const selectSavedChart = localStorage.getItem("savedChartData");

      if (filterDataVal) {
        this.filterData = filterDataVal; // Adjust this according to your API response structure
        this.selectedFilter = this.filterData.name;
        this.populateFieldsFromFilter(this.filterData);
        let type = this.selectedType;

        if (this.$route.name === "DataManagement") {
          this.$emit("filterApplied", { filterData: this.filterData, type });
          return;
        }

        if (type) {
          this.$emit("filter-data", { filterData: this.filterData, type });
        } else {
          // In studio mode when no chart is selected, preserve the filter for later use
          if (this.$route.name === "FluidsDataStudioTwo") {
            // Store the filter data in localStorage for later application
            localStorage.setItem("pendingFilterData", JSON.stringify(this.filterData));
            localStorage.setItem("filterActive", "true");
            // Don't clear the UI - keep the filter selections visible
            this.showSnackbar("Filter saved. It will be applied when you select a chart.", "success");
          } else {
            this.showSnackbar("Please select chart first.", "error");
            this.resetFilter();
          }
        }
      } else {
        if (getDefaultFilterID && selectSavedChart) {
          try {
            // API call (URL remains unchanged)
            const response = await api.get("public/api/filters/default");

            if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
              this.filterData = response.data.data.filter; // Adjust this according to your API response structure
              this.selectedFilter = this.filterData.name;
              this.populateFieldsFromFilter(this.filterData);
              let type = this.selectedType;

              if (this.$route.name === "DataManagement") {
                this.$emit("filterApplied", { filterData: this.filterData, type });
                return;
              }

              if (type) {
                this.$emit("filter-data", { filterData: this.filterData, type });
              } else {
                // In studio mode when no chart is selected, preserve the filter for later use
                if (this.$route.name === "FluidsDataStudioTwo") {
                  // Store the filter data in localStorage for later application
                  localStorage.setItem("pendingFilterData", JSON.stringify(this.filterData));
                  localStorage.setItem("filterActive", "true");
                  // Don't clear the UI - keep the filter selections visible
                  this.showSnackbar("Filter saved. It will be applied when you select a chart.", "success");
                } else {
                  this.showSnackbar("Please select chart first.", "error");
                  this.resetFilter();
                }
              }
            } else if (response && response.data && response.data.message) {
              console.error(response.data.message);
            } else {
              console.error("Error fetching filter details");
            }
          } catch (error) {
            console.error("Error fetching filter details:", error);
          }
        }
      }
    },

    formatDate() {
      const isValidDate = (date) => {
        return !isNaN(Date.parse(date));
      };

      if (this.minDate && isValidDate(this.minDate)) {
        this.minDate = new Date(this.minDate).toISOString().split("T")[0];
      } else {
        this.minDate = null; // or some default value
      }

      if (this.maxDate && isValidDate(this.maxDate)) {
        this.maxDate = new Date(this.maxDate).toISOString().split("T")[0];
      } else {
        this.maxDate = null; // or some default value
      }

      return {
        min: this.minDate,
        max: this.maxDate,
      };
    },

    formatNumber(value) {
      return value ? parseFloat(value) : null;
    },
    resetSelectedFilter() {
      localStorage.removeItem("selectedFilterData")
      localStorage.removeItem("selectedFilterId")
      localStorage.removeItem("lastFilterId")
      localStorage.removeItem("pendingFilterData")
      localStorage.removeItem("filterActive")
      this.resetFilter()
      var resetSavedFilter = true;
      //this.$emit('filterApplied', { filterData: this.filterData });
      this.$emit('resetFiltersEmittedUpdated');
      this.$emit('reset-saved-filter', resetSavedFilter);
    },
    resetFields() {
      this.fields = [];
      this.wells = [];
      this.reservoirs = [];
      this.filterData = null;
      this.filterName = null;
      this.selectedFilter = null;
      this.selectedAsset = [];
      this.selectedField = [];
      this.selectedWell = [];
      this.selectedReservoir = [];
      this.minDate = null;
      this.maxDate = null;
      this.selectedSampleKind = [];
      this.selectedSampleType = [];
      this.selectedfluidClassification = [];
      this.selectedSampleID = [];
      this.minDepth = null;
      this.maxDepth = null;
      this.minFormationPressure = null;
      this.maxFormationPressure = null;
      this.minFormationTemperature = null;
      this.maxFormationTemperature = null;
      this.fluidSampleID = [];
      this.fluidSampleContainerID = [];
      this.maxSamples = null;
      this.source = null;
      localStorage.removeItem("filterApplied");
    },
    resetFilter() {
      this.selectedFilter = null;
      this.filterName = null;
      this.selectedAsset = [];
      this.previousSelectedAssets = [];
      this.selectedField = [];
      this.previousSelectedFields = [];
      this.selectedWell = [];
      this.previousSelectedWells = [];
      this.selectedReservoir = [];
      this.previousSelectedReservoir = [];
      this.minDate = null;
      this.maxDate = null;
      this.selectedSampleKind = [];
      this.previousSelectedSampleKinds = [];
      this.selectedSampleType = [];
      this.previousSelectedSampleTypes = [];
      this.selectedfluidClassification = [];
      this.previousSelectedfluidClassifications = [];
      this.selectedSampleID = [];
      this.previousSelectedSampleIDs = [];
      this.minDepth = null;
      this.maxDepth = null;
      this.minFormationPressure = null;
      this.maxFormationPressure = null;
      this.minFormationTemperature = null;
      this.maxFormationTemperature = null;
      this.fluidSampleID = [];  // Reset fluidSampleID
      this.fluidSampleContainerID = [];
      this.maxSamples = null;
      this.source = null;
      localStorage.removeItem("filterApplied");
      localStorage.removeItem("pendingFilterData");
      localStorage.removeItem("filterActive");
      this.getAllSampleKinds();
      this.getAllSampleTypes();
      this.getAllfluidClassifications();
      this.getAllSampleIDs();
      this.getAllAssets([]);
      this.fetchField([], []);
      this.fetchWell([], [], [], []);
      this.fetchReservoir([], [], [], []);
      // let type = this.selectedType;
      // this.updateFilterData();

      // if (type) {
      //   this.$emit('filter-data', { filterData: this.filterData, type });
      // }
    },
    // async confirmDefaultFilter() {
    //   this.defaultLoading = true;
    //   const defaultFilter = {
    //     filterID: this.filterID,
    //     username: this.userFullName
    //   }
    //   const requestBody = {
    //     Data: {
    //       DefaultFilter: defaultFilter,
    //     },
    //   };

    //   try {
    //     await api.post("public/api/filters/default", requestBody);
    //     localStorage.setItem("defaultFilter", requestBody.Data.DefaultFilter.filterID);
    //     this.defaultLoading = false;
    //     this.showDefaultDialog = false;
    //   } catch (error) {
    //     console.error(error);
    //     this.defaultLoading = false;
    //     this.showDefaultDialog = false;
    //   }
    // },
    saveFilterWithChart() {
      // Check for pending filter data first
      const pendingFilterData = localStorage.getItem("pendingFilterData");
      const filterActive = localStorage.getItem("filterActive");
      
      let filter = {};
      
      if (pendingFilterData && filterActive === "true") {
        try {
          // Use pending filter data if available
          const pendingFilter = JSON.parse(pendingFilterData);
          filter = {
            ID: pendingFilter.ID || this.filterID,
            name: pendingFilter.name || this.filterName,
            asset: pendingFilter.asset || this.selectedAsset,
            field: pendingFilter.field || this.selectedField,
            reservoir: pendingFilter.reservoir || this.selectedReservoir,
            well: pendingFilter.well || this.selectedWell,
            sampleDate: pendingFilter.sampleDate || this.formatDate(),
            fluidType: pendingFilter.fluidType || this.selectedSampleKind,
            sampleType: pendingFilter.sampleType || this.selectedSampleType,
            fluidClassification: pendingFilter.fluidClassification || this.selectedfluidClassification,
            fluidSampleID: pendingFilter.fluidSampleID || this.selectedSampleID,
            fluidSampleContainerID: pendingFilter.fluidSampleContainerID || this.fluidSampleContainerID || [],
            source: pendingFilter.source || this.source,
            user: pendingFilter.user || this.userFullName,
            public: true,
          };
          console.log("Using pending filter data for chart creation:", filter);
        } catch (error) {
          console.error("Error parsing pending filter data:", error);
          // Fall back to current UI data
          filter = this.getCurrentFilterData();
        }
      } else {
        // Use current UI data
        filter = this.getCurrentFilterData();
      }
      
      return filter;
    },
    
    getCurrentFilterData() {
      return {
        ID: this.filterID,
        name: this.filterName,
        asset: this.selectedAsset,
        field: this.selectedField,
        reservoir: this.selectedReservoir,
        well: this.selectedWell,
        sampleDate: this.formatDate(),
        fluidType: this.selectedSampleKind,
        sampleType: this.selectedSampleType,
        fluidClassification: this.selectedfluidClassification,
        fluidSampleID: this.selectedSampleID,
        fluidSampleContainerID: this.fluidSampleContainerID
          ? this.fluidSampleContainerID
          : [],
        source: this.source,
        user: this.userFullName,
        public: true,
      };
    },
    
    clearPendingFilters() {
      // Clear pending filter data after successful chart creation/editing
      localStorage.removeItem("pendingFilterData");
      localStorage.removeItem("filterActive");
      console.log("Cleared pending filter data after chart operation");
    },
    async saveFilter() {
      if (!this.filterName || this.filterName.trim() === "") {
        this.showSnackbar("Please set a filter name first.", "error");
        return;
      }

      this.createLoading = true;
      const maxSamplesNumber = parseInt(this.maxSamples);
      const filter = {
        name: this.filterName,
        asset: this.selectedAsset,
        field: this.selectedField,
        reservoir: this.selectedReservoir,
        well: this.selectedWell,
        sampleDate: this.formatDate(),
        fluidType: this.selectedSampleKind,
        sampleType: this.selectedSampleType,
        fluidClassification: this.selectedfluidClassification,
        fluidSampleID: this.selectedSampleID,
        depth: {
          min: this.formatNumber(this.minDepth),
          max: this.formatNumber(this.maxDepth),
        },
        formationPressure: {
          min: this.formatNumber(this.minFormationPressure),
          max: this.formatNumber(this.maxFormationPressure),
        },
        formationTemperature: {
          min: this.formatNumber(this.minFormationTemperature),
          max: this.formatNumber(this.maxFormationTemperature),
        },
        fluidSampleContainerID: this.fluidSampleContainerID
          ? this.fluidSampleContainerID
          : [],
        maxSamples: maxSamplesNumber,
        source: this.source,
        user: this.userFullName,
        public: true,
      };

      const requestBody = {
        Data: {
          Filter: filter,
        },
      };

      try {
        await api.post("public/api/filters", requestBody);
        // this.resetFilter();
        this.fluidSampleID = [];
        this.fluidSampleContainerID = [];
        this.getAllfilters();
        this.$emit("updateFilter");
        this.createLoading = false;
      } catch (error) {
        const err = error.response.data.error;
        this.showSnackbar(err, "error");
        this.resetFilter();
        this.createLoading = false;
      }
    },
    populateFieldsFromFilter(selectedFilter) {
      this.filterData = selectedFilter;
      this.filterName = selectedFilter.name;
      this.selectedAsset = selectedFilter.asset || [];
      this.selectedField = selectedFilter.field || [];
      this.selectedWell = selectedFilter.well || [];
      this.selectedReservoir = selectedFilter.reservoir || [];
      this.minDate = selectedFilter.sampleDate
        ? new Date(selectedFilter.sampleDate.min)
        : null;
      this.maxDate = selectedFilter.sampleDate
        ? new Date(selectedFilter.sampleDate.max)
        : null;
      this.selectedSampleKind = selectedFilter.fluidType || [];
      this.selectedSampleType = selectedFilter.sampleType || [];
      this.selectedfluidClassification = selectedFilter.fluidClassification || [];
      this.selectedSampleID = selectedFilter.fluidSampleID && selectedFilter.fluidSampleID.length > 0 ? selectedFilter.fluidSampleID : [];
      this.minDepth = selectedFilter.depth ? selectedFilter.depth.min : null;
      this.maxDepth = selectedFilter.depth ? selectedFilter.depth.max : null;
      this.minFormationPressure = selectedFilter.formationPressure
        ? selectedFilter.formationPressure.min
        : null;
      this.maxFormationPressure = selectedFilter.formationPressure
        ? selectedFilter.formationPressure.max
        : null;
      this.minFormationTemperature = selectedFilter.formationTemperature
        ? selectedFilter.formationTemperature.min
        : null;
      this.maxFormationTemperature = selectedFilter.formationTemperature
        ? selectedFilter.formationTemperature.max
        : null;
      this.fluidSampleID = selectedFilter.fluidSampleID && selectedFilter.fluidSampleID.length > 0 ? selectedFilter.fluidSampleID : [];
      this.fluidSampleContainerID = selectedFilter.fluidSampleContainerID && selectedFilter.fluidSampleContainerID.length > 0 ? selectedFilter.fluidSampleContainerID : [];
      this.maxSamples = selectedFilter.maxSamples;
      this.source = selectedFilter.source;
      if (this.fluidSampleID && this.selectedAsset.length > 0) {
        this.fetchField(this.fluidSampleID, this.selectedAsset);
      }
      if ((this.fluidSampleID || this.selectedAsset.length > 0 || this.selectedField.length > 0)) {
        this.fetchWell(this.fluidSampleID, this.selectedAsset, this.selectedField, []);
        this.fetchReservoir(this.fluidSampleID, this.selectedAsset, this.selectedField);
      }
      if ((this.fluidSampleID || this.selectedAsset.length > 0 || this.selectedField.length > 0 || this.selectedReservoir.length > 0)) {
        this.fetchWell(this.fluidSampleID, this.selectedAsset, this.selectedField, this.selectedReservoir);
        this.fetchReservoir(this.fluidSampleID, this.selectedAsset, this.selectedField);
      }

    },
    showDeleteConfirmation() {
      this.confirmDeleteDialog = true;
    },
    closeDeleteConfirmation() {
      this.confirmDeleteDialog = false;
    },
    debugLog() {
      console.log("call")
    },
    deleteFilter() {
      this.deleteLoading = true;
      let defaultFilterID = localStorage.getItem("defaultFilter");
      let selectedFilterId = localStorage.getItem("selectedFilterId");
      if (selectedFilterId) {
        api
          .delete(`public/api/filters/${selectedFilterId}`)
          .then((response) => {
            if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
              if (defaultFilterID === selectedFilterId) {
                localStorage.removeItem("defaultFilter")
              }
              localStorage.removeItem("selectedFilterId")
              this.getAllfilters(); // Refresh filters list
              this.resetSelectedFilter();
              this.$emit('update-chart');
              this.$emit("updateFilter");
              this.confirmDeleteDialog = false; // Close the confirmation dialog
            }
            else if (response && response.data && response.data.message) {
              console.error(response.data.message);
            }
            else {
              console.error("Error deleting filter");
            }
          })
          .catch((error) => {
            console.log("Error deleting filter:", error);
          })
          .finally(() => {
            this.deleteLoading = false;
          });
      }
    },
    async updateFilter() {
      let selectedFilterId = localStorage.getItem("selectedFilterId");
      this.updateLoading = true;
      const maxSamplesNumber = parseInt(this.maxSamples);
      const filter = {
        name: this.filterName,
        asset: this.selectedAsset,
        field: this.selectedField,
        reservoir: this.selectedReservoir,
        well: this.selectedWell,
        sampleDate: this.formatDate(),
        fluidType: this.selectedSampleKind,
        sampleType: this.selectedSampleType,
        fluidClassification: this.selectedfluidClassification,
        fluidSampleID: this.selectedSampleID,
        depth: {
          min: this.formatNumber(this.minDepth),
          max: this.formatNumber(this.maxDepth),
        },
        formationPressure: {
          min: this.formatNumber(this.minFormationPressure),
          max: this.formatNumber(this.maxFormationPressure),
        },
        formationTemperature: {
          min: this.formatNumber(this.minFormationTemperature),
          max: this.formatNumber(this.maxFormationTemperature),
        },
        fluidSampleContainerID: this.fluidSampleContainerID
          ? this.fluidSampleContainerID
          : [],
        maxSamples: maxSamplesNumber,
        source: this.source,
        user: this.userFullName,
        public: true,
      };

      const requestBody = {
        Data: {
          Filter: filter,
        },
      };

      try {
        await api.put(
          `public/api/filters/${selectedFilterId}`,
          requestBody
        );
        // this.resetFilter();
        this.getAllfilters(); // Refresh filters list
        this.$emit("updateFilter");
        this.updateLoading = false;
      } catch (error) {
        console.error(error);
        this.updateLoading = false;
      }
    },
  },
  mounted() {
    this.defaultFilterData();
    this.getAllfilters();
    this.getAllSampleKinds();
    this.getAllSampleTypes();
    this.getAllfluidClassifications();
    this.getAllSampleIDs();
    this.getAllAssets([]);
    this.fetchField([], []);
    this.fetchWell([], [], [], []);
    this.fetchReservoir([], [], [], []);
    localStorage.removeItem("filterApplied");
    localStorage.removeItem("filterActive");
    localStorage.removeItem("selectedFilterId")
    const sidebarState = localStorage.getItem('sidebarState');
    if (sidebarState) {
      // If a state exists in localStorage, set the initial state
      if (sidebarState === 'true') {
        this.toggleDrawer();
      } else if (sidebarState === 'close') {
        this.drawer = false;
        this.rail = false;
      }
    }
    // this.checkScreenWidth();
    // window.addEventListener("resize", this.checkScreenWidth);
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenWidth);
    window.removeEventListener("keydown", this.handleKeydown);
  },
};
</script>